import { render, staticRenderFns } from "./BusinessMaintenancePage.vue?vue&type=template&id=1809d70a&scoped=true&"
import script from "./BusinessMaintenancePage.vue?vue&type=script&lang=js&"
export * from "./BusinessMaintenancePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1809d70a",
  null
  
)

export default component.exports